import type { AudioCatalogItem } from './api';

/** 素材ピッカーの「提供ライブラリ」に出す用途 (audio_catalog_items.default_audio_role)。 */
export type AudioCatalogRole = 'bgm' | 'sound_effect';

/** カタログからその用途の項目だけを、パートナー独自 → 共通の順に並べる。 */
export function filterAudioCatalogByRole(items: AudioCatalogItem[], role: AudioCatalogRole): AudioCatalogItem[] {
  const matched = items.filter((item) => item.default_audio_role === role);
  return [
    ...matched.filter((item) => item.scope === 'partner'),
    ...matched.filter((item) => item.scope !== 'partner'),
  ];
}
